export default __webpack_public_path__ + "static/media/img_api_01.397bfc10.png";